module.exports = __webpack_public_path__ + "img/toggle-unselect.b09b3441.png";